module.exports = __webpack_public_path__ + "img/A_mask.812ba1bc.png";